export const CONTACT = {
  email: "dxb@fadinvestment.com",
  whatsapp: "+971501242886",
  whatsappDisplay: "+971 50 124 2886",
  address: "3204, Building 3B, Gold and Diamond Park, Dubai",
};

export const PORTRAIT_URL = "/img/fad-portrait.jpg";

export const scrollToId = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};
